module.exports = __webpack_public_path__ + "img/示例图_5-1.cdce34f0.png";